import { Col, Form, Input, Radio, Row } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { FormComponentProps } from "antd/lib/form";
import { LearnChannelSelect } from "components/forms/LearnChannelSelect";
import { ModalSubmitButton } from "components/forms/ModalSubmitButton";
import { YituDeclareCheckBox } from "components/forms/YituDeclareCheckBox";
import _ from "lodash";
import React from "react";
import { setCaptcha } from "../../../utils/captcha";
import {
  fetchDictionary,
  useCorporateDicts
} from "../../BecomePartnerModal/api";
import "./index.scss";
import { IDictItem } from "components/forms/model";
import { NcCaptcha } from "components/forms/NcCaptcha";

interface IProps extends FormComponentProps {}

export const BusinessConsultForm: React.SFC<IProps> = React.memo(props => {
  const { consultIndustryType, learnAboutChannel } = useCorporateDicts();
  const FormItem = Form.Item;
  const { form } = props;
  const getFD = form.getFieldDecorator;

  // 我们希望其他放在最后
  const fixedLearnAboutChannelItems = [
    ...learnAboutChannel.filter(item => item.entryKey !== "other"),
    ...learnAboutChannel.filter(item => item.entryKey === "other")
  ];

  // TODO: 两列布局
  return (
    <Form className="BusinessConsultForm">
      <FormItem
        className="BusinessConsultForm-item"
        label={"您所在的行业"}
        colon={false}
      >
        {getFD("consultIndustryType", {
          rules: [{ required: true, message: "请选择您所在的行业" }]
        })(
          <Radio.Group className="BusinessConsultForm-radioGroup">
            <Row>
              {_.map(consultIndustryType, (item: IDictItem) => {
                return (
                  <Col span={4} md={12} lg={4} key={item.entryKey}>
                    <Radio value={item.entryKey}>{item.entryValue}</Radio>
                  </Col>
                );
              })}
            </Row>
          </Radio.Group>
        )}
      </FormItem>

      {/** 客户信息 */}
      <FormItem
        className="BusinessConsultForm-item"
        label={"公司名称"}
        colon={false}
      >
        {getFD("companyName", {
          rules: [{ required: true, message: "请输入公司名称" }]
        })(
          <Input
            placeholder="请输入公司名称"
            className="BusinessConsultForm-text-input"
          />
        )}
      </FormItem>

      <FormItem
        className="BusinessConsultForm-item"
        label={"您的姓名"}
        colon={false}
      >
        {getFD("name", {
          rules: [{ required: true, message: "请输入您的姓名" }]
        })(
          <Input
            placeholder="请输入您的姓名"
            className="BusinessConsultForm-text-input"
          />
        )}
      </FormItem>

      <Row gutter={[16, 0]}>
        <Col span={24} md={12}>
          <FormItem
            className="BusinessConsultForm-item"
            label={"手机号码"}
            colon={false}
          >
            {getFD("telephoneNum", {
              rules: [
                {
                  required: true,
                  message: "请输入手机号码",
                  pattern: /^1(3|4|5|6|7|8|9)\d{9}$/
                }
              ]
            })(
              <Input
                placeholder="请输入手机号码"
                className="BusinessConsultForm-text-input"
              />
            )}
          </FormItem>
        </Col>

        <Col span={24} md={12}>
          <FormItem
            className="BusinessConsultForm-item"
            label={"邮箱地址"}
            colon={false}
          >
            {getFD("email", {
              rules: [
                {
                  required: true,
                  message: "请输入邮箱地址"
                },
                {
                  message: "请输入有效的邮箱地址",
                  pattern: /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
                }
              ]
            })(<Input placeholder="请输入邮箱地址" />)}
          </FormItem>
        </Col>
      </Row>

      <FormItem
        className="BusinessConsultForm-item"
        label={"您需要咨询的事宜"}
        colon={false}
      >
        {getFD("content", {
          rules: [{ required: true, message: "请输入您需要咨询的事宜" }]
        })(
          <Input.TextArea
            className="BusinessConsultForm-note"
            placeholder="请输入您需要咨询的事宜"
            autosize={{ minRows: 5 }}
          />
        )}
      </FormItem>

      <FormItem label="您是如何得知依图的？(可多选)" colon={false}>
        {getFD("learnAboutChannel", {
          rules: [
            {
              required: true,
              message: "您是如何得知依图的？(可多选)"
            }
          ]
        })(
          <LearnChannelSelect form={form} dicts={fixedLearnAboutChannelItems} />
        )}
      </FormItem>

      {/** 声明 */}
      {getFD("legalAgreement", {
        rules: [{ required: true, message: "请阅读声明" }]
      })(<YituDeclareCheckBox />)}

      {/** 人机校验 */}
      <Form.Item label={null}>
        {getFD("ncParams", {
          rules: [{ required: true, message: "请完成人机验证" }]
        })(<NcCaptcha />)}
      </Form.Item>
    </Form>
  );
});
